import * as React from 'react';
import * as _ from 'underscore';

import { ConnectedExplorer } from '../app/spaces/Explorer/ConnectedExplorer';
import { PropsForExplorerToolbar } from '../app/spaces/Explorer/Explorer';
import { ConnectedQueryParamUpdateProvider } from '../app/spaces/RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../app/spaces/RouterHelpers/SpaceInfoProvider';
import { newWorkbookButton } from '../app/spaces/SiteUserSpace/SiteSpaceHeaderButtons';
import { ConnectedExplorerSubspaceInitializer } from '../app/spaces/SpaceConfig/ExplorerSubspaceInitializer';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../app/state/SpaceInfo';
import { SpaceContainerStyles } from '../style/SpaceContainerStyles';
import { AngularContext } from '../ts/factories/AngularContextFactory';
import { FeatureFlags } from '../ts/FeatureFlags';
import { IContentType } from '../ts/models/ContentTypes';
import { CatalogContentType } from './CatalogContentType';
import { ExplorableItemDefinition } from '../ts/models/contentDefinitions/ContentDefinitionsTypes';

export interface CatalogBrowserSubspaceExplorerProps {
  readonly subspaceName: CatalogContentType;
  readonly routeLocationSearch: string;
  readonly angularContext: AngularContext;
  readonly contentDefinition: ExplorableItemDefinition;
  readonly contentType: IContentType;
}

export function CatalogBrowserSubspaceExplorer(props: CatalogBrowserSubspaceExplorerProps): JSX.Element {

  const queryUpdaterProps = {
    routeLocationPath: '',
    routeLocationSearch: props.routeLocationSearch,
    shouldUpdateContentTypes: true,
    shouldUpdateFilters: true,
    shouldUpdateBreadcrumbs: false, // Breadcrumbs are updated by the DC3 code
    shouldUpdateSort: true
  };

  // The catalog space is scoped to the site and has its own subspaces, but it's not the same as the explore space,
  // so we should likely give it its own space type.
  // See https://gitlab.tableausoftware.com/browser-clients/vizportalclient/merge_requests/2733/diffs#note_651328
  const spaceInfo: SpaceInfo = {
    item: SpaceItemForNonEntitySpace,
    spaceType: 'site',
    subspaceName: props.subspaceName,
  };

  const baseToolbarProps: PropsForExplorerToolbar = {
    supportFilterPanel: props.contentType.canShowFilterPanel,
    toolbarVisibility: 'enabled',
  };

  return (
    <div className={SpaceContainerStyles.SubplaceArea}>
      <ConnectedSpaceInfoProvider spaceInfo={spaceInfo}>
        <ConnectedQueryParamUpdateProvider {...queryUpdaterProps}>
          <ConnectedExplorerSubspaceInitializer routeLocationSearch={props.routeLocationSearch} spaceInfo={spaceInfo}>
            <ConnectedExplorer
              angularContext={props.angularContext}
              supportedDisplayModes={props.contentDefinition.supportedDisplayModes}
              toolbarProps={FeatureFlags.newWorkbookFromCatalog
                ? {...baseToolbarProps, toolbarContentSpecificControls: { beginning: newWorkbookButton() }}
                : baseToolbarProps}
            />
          </ConnectedExplorerSubspaceInitializer>
        </ConnectedQueryParamUpdateProvider>
      </ConnectedSpaceInfoProvider>
    </div>
  );
}
